import { DashboardNotification } from '@web/dashboard/types/DashboardNotification';
import { DashboardNotificationType } from '@web/dashboard/types';
import type { TimesheetsDashboardNotification } from '@web/timesheets/types/TimesheetsDashboardNotification';

export const isShiftFeedbackDashboardNotification = (
  notification: DashboardNotification
): notification is TimesheetsDashboardNotification =>
  (notification as TimesheetsDashboardNotification).type ===
  DashboardNotificationType.shiftFeedbackRequested;
